var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[_vm._v(" "+_vm._s(_vm.getMessage_('QWCC002063'))+" "),_c('sf-card',{staticClass:"w-100 h-100 pt-3"},[_c('bar-chart',{ref:"grpBar",attrs:{"height":277,"chartData":_vm.dataCollection,"options":_vm.options}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }